import { Component, OnInit } from '@angular/core';
import { CustomCookieService } from '../../../../../shared/services/custom-cookie.service';
import { HelpersService } from '../../../../../shared/services/helpers.service';
import { ExternalCode } from '../../../../../shared/common/classes';
import { fadeOutOnLeaveAnimation, fadeInOnEnterAnimation } from 'angular-animations';
import { AuthorizationService } from '../../../../../shared/services/authorization.service';

@Component({
  selector: 'app-order-confirmation',
  templateUrl: './order-confirmation.component.html',
  styleUrls: ['./order-confirmation.component.scss'],
  animations: [
    fadeInOnEnterAnimation(),
    fadeOutOnLeaveAnimation()
  ]
})
export class OrderConfirmationComponent implements OnInit {
  public selectedMdn = this.customCookieService.getData('ui-selectedMdn', true);
  public redirectUri = this.customCookieService.getData('ui-redirect_uri', true);
  constructor(
    private customCookieService: CustomCookieService,
    private helpersService: HelpersService,
    private authorizationService: AuthorizationService
  ) { }

  public onBackToOem() {
    this.helpersService.navigateBackToOEM(ExternalCode.SUCCESSFUL_CONFIRMATION)
  }

  ngOnInit(): void {
    this.authorizationService.signOut().subscribe(() => {
      this.customCookieService.saveData('ui-selectedMdn', this.selectedMdn, '/', true);
      this.customCookieService.saveData('ui-redirect_uri', this.redirectUri, '/', true);
    })
  }

}
